import React from 'react';
import { Flex } from 'rebass';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { HazardSurveyStatusPicker } from '@/components/WaterHazard/HazardSurveyStatusPicker';
import { HazardSurveyStatus } from '@/services/hazardSurvey';
import { FormComboGroup, Input, SearchInput, Select } from '@/components/Form';
import Button from '../../../../components/Button/Button';
import { rebassProps } from '@/theme/theme';
import { FilterBarProps } from '@/components/FilterBar/FilterBar';
import { getStringSearchPlaceholder } from '@/helpers/search';

const resultOptions = [
  {
    value: 'ALL',
    label: '- result -',
  },
  {
    value: 'PASS',
    label: 'Pass',
  },
  {
    value: 'FAIL',
    label: 'Fail',
  },
  {
    value: 'FAILPASS',
    label: 'Fail/Pass',
  },
];

export const stringSearchFields = [
  {
    field: 'id',
    label: 'Job',
  },
  {
    field: 'address.street1',
    label: 'Address',
  },
  {
    field: 'address.street2',
    label: null,
  },
  {
    field: 'waterHazardSurvey.waterService.siteNumber',
    label: 'Service',
  },
  {
    field: 'waterHazardSurvey.waterService.hazardSite.name',
    label: 'Site',
  },
  {
    field: 'waterHazardSurvey.contact.name',
    label: 'Contact',
  },
];

export const dateOptions = [
  {
    field: 'created',
    label: 'Ordered',
  },
  // {
  //   field: 'assigned',
  //   label: 'Assigned',
  // },
  // {
  //   field: 'completed',
  //   label: 'Completed',
  // },
  // {
  //   field: 'submitted',
  //   label: 'Submitted',
  // },
];

export type JobFilters = {
  status?: HazardSurveyStatus[];
  testResult?: string;
  stringSearch?: string;
  currentDateFilterField?: string;
  dateStart?: string;
  dateEnd?: string;
  flags?: string[];
};

export const defaultFilters: JobFilters = {
  status: ['NEW', 'IN_PROGRESS', 'IN_REVIEW'],
};

type FilterBarJobProps = FilterBarProps<JobFilters>;

const FilterBarHazardSurvey: React.FC<FilterBarJobProps> = (props) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (e: any) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          autoFocus={isBrowser && !selectedId}
          width={300}
          name="stringSearch"
          value={filters.stringSearch || ''}
          onChange={onChange}
        />
        <HazardSurveyStatusPicker
          value={filters.status}
          onChange={(values) => setFilters({ ...filters, status: values })}
        />
        <FormComboGroup>
          <Select
            name="currentDateFilterField"
            value={filters.currentDateFilterField || 'ALL'}
            onChange={onChange}
            variant={
              filters.currentDateFilterField &&
              filters.currentDateFilterField !== 'ALL'
                ? 'inputRoundedLeft'
                : 'input'
            }
            width={130}
          >
            <option value="ALL">- date -</option>
            {dateOptions.map((dateOption, i) => (
              <option value={dateOption.field} key={i}>
                {dateOption.label}
              </option>
            ))}
          </Select>
          {filters.currentDateFilterField &&
            filters.currentDateFilterField !== 'ALL' && (
              <>
                <Input
                  id="dateStart"
                  name="dateStart"
                  variant="inputSquare"
                  type="date"
                  width={150}
                  value={filters.dateStart || ''}
                  onChange={onChange}
                />
                <Input
                  id="dateEnd"
                  name="dateEnd"
                  type="date"
                  width={150}
                  variant="inputRoundedRight"
                  value={filters.dateEnd || ''}
                  onChange={onChange}
                />
              </>
            )}
        </FormComboGroup>
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => setFilters(defaultFilters)}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

FilterBarHazardSurvey.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarHazardSurvey;
